import React from 'react';
const SmallCopyRight = () => {
    const year = new Date().getFullYear();
    return (
        <div id="footer-wrapper" className="text-center">
            <span className="copyright">
                Powered by{' '}
                <a
                    title="ECI Software Solutions, Inc."
                    rel="noopener noreferrer"
                    target="_blank"
                    href="http://www.ecisolutions.com">
                    ECi Software Solutions
                </a>
                , Inc. &copy;2006-{year} ECi Software Solutions, Inc.
            </span>
        </div>
    );
};

export default SmallCopyRight;
